export const API_ERROR = "api_failed";

export const DB_MAIN_DATA = "DB_Main_data";
export const DB_MAIN_DATA_SUCCESS = "DB_Main_data_success";